module.exports = __webpack_public_path__ + "img/cloudstorage.57e4a15.svg";